import { render, staticRenderFns } from "./NanHaiPensionServiceSystem.vue?vue&type=template&id=3f578f2a&"
import script from "./NanHaiPensionServiceSystem.vue?vue&type=script&lang=js&"
export * from "./NanHaiPensionServiceSystem.vue?vue&type=script&lang=js&"
import style0 from "./NanHaiPensionServiceSystem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports